import './recurring-payment-icon.scss';

const RecurringPaymentIcon = () => (<i className="icon-icon-recurring-payment"></i>);

export default RecurringPaymentIcon;